<div class="staff-warehouse-cell-picker">
  @if (loadingWarehouse()) {
    <p class="staff-warehouse-cell-picker__state">
      {{ 'common.loading' | translate }}
    </p>
  } @else if (warehouseError(); as error) {
    <p class="staff-warehouse-cell-picker__state staff-warehouse-cell-picker__state--error">
      {{ error }}
    </p>
  } @else if (!hasWarehouseGrid()) {
    <p class="staff-warehouse-cell-picker__state staff-warehouse-cell-picker__state--warn">
      {{ 'admin.warehouses.placement.noGridConfig' | translate }}
    </p>
  } @else {
    <div class="staff-warehouse-cell-picker__coords">
      <lib-not-input
        type="dropdown"
        [ngModel]="rowNumber()"
        (ngModelChange)="onRowModelChange($event)"
        [label]="'admin.warehouses.placement.row' | translate"
        [options]="rowDropdownOptions()"
        [placeholder]="'admin.warehouses.placement.selectPlaceholder' | translate"
        [disabled]="disabled()"
        [hideErrorBlock]="true"
        [height]="'56px'"
      />
      <lib-not-input
        type="dropdown"
        [ngModel]="floor()"
        (ngModelChange)="onFloorModelChange($event)"
        [label]="'admin.warehouses.placement.floor' | translate"
        [options]="floorDropdownOptions()"
        [placeholder]="'admin.warehouses.placement.selectPlaceholder' | translate"
        [disabled]="disabled() || rowNumber() === null"
        [hideErrorBlock]="true"
        [height]="'56px'"
      />
      <lib-not-input
        type="dropdown"
        [ngModel]="colNumber()"
        (ngModelChange)="onColumnModelChange($event)"
        [label]="'admin.warehouses.placement.column' | translate"
        [options]="columnDropdownOptions()"
        [placeholder]="'admin.warehouses.placement.selectPlaceholder' | translate"
        [disabled]="disabled() || rowNumber() === null"
        [hideErrorBlock]="true"
        [height]="'56px'"
      />
    </div>

    <lib-not-button
      [text]="'admin.warehouses.placement.addCell' | translate"
      [color]="'#0B6270'"
      [bgColor]="'#DCF6F2'"
      [disabled]="disabled() || !canAddCell()"
      [action]="{ type: 'action' }"
      (actionEvent)="addCurrentCell()"
    />

    @if (selectedCellLabels().length > 0) {
      <section class="staff-warehouse-cell-picker__selected">
        <h4 class="staff-warehouse-cell-picker__selected-title">
          {{ 'admin.warehouses.placement.selectedCells' | translate }}
        </h4>
        <ul class="staff-warehouse-cell-picker__selected-list">
          @for (cell of selectedCellLabels(); track cell.key) {
            <li class="staff-warehouse-cell-picker__selected-item">
              <span>{{ cell.label }}</span>
              <button
                type="button"
                class="staff-warehouse-cell-picker__selected-remove"
                [disabled]="disabled()"
                [attr.aria-label]="'admin.warehouses.placement.removeCell' | translate"
                (click)="removeCell(cell.key)"
              >
                ×
              </button>
            </li>
          }
        </ul>
      </section>
    }

    <div class="staff-warehouse-cell-picker__actions">
      @if (showCancel()) {
        <lib-not-button
          type="button"
          size="big"
          [text]="'common.actions.cancel' | translate"
          [bgColor]="'rgba(55, 190, 176, 0.12)'"
          [color]="'#140342'"
          [width]="'100%'"
          [disabled]="submitting()"
          [action]="{ type: 'action' }"
          (actionEvent)="onCancel()"
        />
      }
      <lib-cabinet-button
        variant="primary"
        size="lg"
        [fullWidth]="true"
        [text]="submitLabelKey() | translate"
        [action]="{ type: 'action' }"
        [disabled]="!canSubmit()"
        [isLoading]="submitting()"
        (actionEvent)="onSubmit()"
      />
    </div>
  }
</div>
